import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFBlueArrowUpSmall from '@/components/UI/svg/Icons/EFBlueArrowUpSmall';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/h5/');

export default function Tail({}: any) {
    const { Link, useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { t: s } = useLang('shared');
    const { locale } = useRouter();

    const EV_LINK: any = {
        us: `https://${locale}.ecoflow.com/products/ev-x-stream-adapter-delta-pro`,
        cis: 'none',
        sa: 'none',
        jp: 'https://jp.ecoflow.com/products/ev-adapter',
        cn: 'https://item.jd.com/10055429332973.html#none',
        kr: 'none',
        br: 'none',
        mx: 'none',
        ph: 'none',
    };

    const shopList = [
        {
            id: 1,
            bgImage: [`08SmartHomePanel.webp`, `08SmartHomePanel.png`],
            desc: t('smart_home_panel'),
            link: ['kr', 'br', 'mx', 'ph'].includes(locale) ? 'none' : '/smart-home-panel',
        },
        {
            id: 2,
            bgImage: [`08EvXStreamADapter.webp`, `08EvXStreamADapter.png`],
            desc: t('EV_adapter'),
            link: EV_LINK[locale] || EV_LINK.us,
        },
    ];

    // US/CA和日本显示 double voltage hub
    const hasDvhCountrys = ['us', 'ca', 'jp', 'br', 'mx'];
    if (hasDvhCountrys.includes(locale)) {
        shopList.push({
            id: 3,
            bgImage: [`08DoubleVoltageHub.webp`, `08DoubleVoltageHub.png`],
            desc: t('DV_hub'),
            link:
                locale === 'jp'
                    ? 'https://jp.ecoflow.com/products/double-voltage-hub'
                    : ['us', 'ca']?.includes(locale)
                    ? `https://${locale}.ecoflow.com/products/double-voltage-hub-ecoflow-delta-pro`
                    : '',
        });
    }

    // ca cn 删除smart home panel
    if (['ca', 'cn'].includes(locale)) {
        shopList.shift();
    }
    const widthA = typeof window !== 'undefined' ? window.innerWidth : 1024;

    return (
        <div className={`${css.tailA} tailA1 GtmModuleData-section`} data-section-id={css.tailA} data-section-title={shopList[0].desc}>
            <div className="product-card-list">
                <Swiper pagination={{ clickable: true }} initialSlide={0} slidesPerView={2} width={widthA} preloadImages={false} lazy={true}>
                    {shopList.map((item: any) => (
                        <SwiperSlide key={item.id}>
                            <div className="product-card">
                                <div className="card-img">
                                    <EFPic name={item.bgImage} alt={item.desc} />
                                </div>
                                <div className="card-title" dangerouslySetInnerHTML={{ __html: item.desc }}></div>
                                <div className="card-link">
                                    {item?.link !== 'none' && item?.link && (
                                        <Link
                                            href={item.link}
                                            className="GtmModuleData-btn-href"
                                            ariaLabel={item.desc}
                                            datalayer={{
                                                __btn_id1: css.tailA,
                                                __btn_id2: item?.link,
                                            }}
                                        >
                                            {s('support.site_support_learn_more')}
                                            <span className="card-icon">
                                                <EFBlueArrowUpSmall />
                                            </span>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
